// extracted by mini-css-extract-plugin
export default {"products":"Rx-z","card":"Sx-z","oosMessaging":"Tx-z"};